<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">
              <form-image-input
                label="صورة الحملة"
                id="form-image"
                name="image"
                v-model="form.image"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                label="اسم حملة التبرع"
                v-model="form.name_ar"
                rules="required"
              />

            </b-col>
            <b-col cols="12">
              <form-select
                label="نوع الحملة"
                :options="optionsType"
                :reduce="(el) => el"
                :getOptionLabel="(x) => x.title"
                v-model="form.campaign_type"
                rules="required"
              />

            </b-col>
            <b-col cols="12">
              <form-select
                multiple
                rules="required"
                label="الفئات المستهدفة"
                id="ageCategory"
                v-model="form.age_category_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="/v2/selects/age-categories"
                :closeOnSelect="false"
              />
            </b-col>
            
            <b-col cols="12" v-if="form.campaign_type">
              <form-mask
                v-if="form.campaign_type.value == 0"
                label="العدد"
                id="number"
                v-model="form.count"
                :raw="false"
                placeholder="10,000"
                options="number"
                rules="required"
              />
              <form-mask
                v-else
                label="مبلغ التبرع"
                id="number"
                v-model="form.campaign_amount"
                :raw="false"
                placeholder="10,000"
                options="number"
                rules="required"
              />
            </b-col>
            <b-col cols="12">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                label="تاريخ بداية الحملة"
                id="start-date"
                v-model="form.start_date"
                rules="required"
              />
            </b-col>
            <b-col cols="12">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                label="تاريخ نهاية الحملة"
                id="end-date"
                v-model="form.end_date"
                rules="required"
              />
              <small
                v-if="form.end_date && checKdifferenceInTime(form.start_date , form.end_date , 0)"
                class="text-danger"
                style="white-space: pre-line"
                >يجب أن يكون تاريخ نهاية الحملة بعد تاريخ بدايتها</small
              >
            </b-col>
            <b-col cols="12">
              <form-select
                label="المحافظة"
                v-model="form.governorate"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x"
                id="sgovernorate_manage_camaping"
                ep="v2/selects/governorates"
                rules="required"
              />
            </b-col>
            <b-col cols="12">

              <b-form-group label="تفاصيل" label-for="details">
                <validation-provider
                  #default="{ errors }"
                  name="حقل التفاصيل"
                  rules="required"
                  id="details"
                  mode="passive"
                >
                  <quill-editor
                    :options="editorOption"
                    v-model="form.description_ar"
                    :class="{ quillEditor: errors.length > 0 }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import { differenceInTime } from "@/utils/utils";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
      optionsType: [
        { value: 1, title: "مادية" },
        { value: 0, title: "عيني" },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success && this.checKdifferenceInTime(this.form.start_date , this.form.end_date , 0) == false) {
          this.$emit("confirm", this.form);
        }
      });
    },
    checKdifferenceInTime(fisrtData , secondData , difference){
      return differenceInTime(fisrtData , secondData , difference)
    }
  },
};
</script>
